import React, { useState } from 'react';
import 'twin.macro';
import NumberInput from 'components/Form/NumberInput';

interface Props {
  value?: number;
  onChange: (v?: number) => void;
  readonly?: boolean;
}

export function NumberCell(props: Props) {
  const { value, onChange } = props;
  const [inputValue, setInputValue] = useState<number | undefined>(value);

  return (
    <NumberInput
      readOnly={props.readonly}
      emptyValue=""
      value={inputValue}
      onChange={e => {
        setInputValue(e);
        onChange(e);
      }}
      tw="text-sm font-medium border-transparent hover:border-neutral-quiet focus:border-neutral-quiet"
    />
  );
}
